import {createSelector} from "reselect";

export const getTema = (state) => state.tema;

export const getMenuDisposition = createSelector(
    getTema,
    (state) => state.isMenuOpen
);